export const baseUrls = {
    api: typeof window !== 'undefined' && window.vendadiretaApiBase
        ? window.vendadiretaApiBase
        : process.env.VUE_APP_API,
    vue: process.env.VUE_APP_LOCAL
};